import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiNeedSmsTfaError } from '@/core/error/transport/customErrors/tmApiNeedSmsTfaError'
import { oauthEndpointProvidersPredicateFn } from '@/services/transport/errorsProcessing/rules/oauth/types'

export const oauth2FARequiredErrorRule: CustomErrorRule = {
  subCodes: ['auth.enter_two_factor_code'],
  klass: TmApiNeedSmsTfaError,
  predicateFn: oauthEndpointProvidersPredicateFn,
}
